<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-row gap-3 items-center">
      <InputGroup class="h-10">
        <InputGroupAddon v-if="exportable"> ** </InputGroupAddon>
        <InputText v-model="name" placeholder="Budget Item Name" class="w-full" />
      </InputGroup>

      <LabeledCheckboxNoForm v-model="exportable" size="w-72" name="exportable" label="Ledger Exportable" />
    </div>
    <StackedLabelDropdownNoForm v-model="costType" name="costType" :options="costTypes" optionsLabel="" label="Cost Type" />
    <StackedLabelDropdownNoForm v-model="custCostType" name="costType" :options="custCostTypes" optionsLabel="name" label="Category" />

    <SubmitButton label="Add Budget Item" class="mt-3" @click="createBudgetItem" />
  </div>
</template>

<script setup lang="ts">
import type { Code } from "@/types/Codes";
import type { StockBudgetItem } from "@/types/StockBudgetItem";

interface Props {
  custCostTypes: Code[];
}
const props = defineProps<Props>();

const emit = defineEmits<{ createItem: [item: StockBudgetItem] }>();

const name = ref<string>("");
const exportable = ref<boolean>(false);
const costType = ref<"INSP" | "NONINSP">("NONINSP");
const custCostType = ref<Code | undefined>(props.custCostTypes.length > 0 ? props.custCostTypes[0] : undefined);
const costTypes = ["INSP", "NONINSP"];

watch(name, (newName: string) => {
  name.value = newName.toUpperCase();
});

const createBudgetItem = (): void => {
  if (name.value == null || name.value.trim().length === 0) {
    error("Name may not be blank", "");
    return;
  }

  if (costType.value == null) {
    error("Cost type may not be blank", "");
    return;
  }

  if (custCostType.value == null) {
    error("Category may not be blank", "");
    return;
  }

  const item: StockBudgetItem = {
    columnOrder: [],
    columns: null,
    costType: costType.value,
    custCostType: custCostType.value.name,
    description: (exportable.value ? "**" : "") + name.value,
    exportable: exportable.value,
    stockBudgetItemId: "",
  };

  emit("createItem", item);
};
</script>
